<template>
  <div class="container-lg">
    <!-- Modal de edición de solicitud -->
    <ModalSolicitud
      ref="modalSolicitud"
      v-on:cerrado="modalEdicionCerrado"
      v-on:editado="editado"
    />
    <ModalMotivoSolicitud
      ref="modalMotivoSolicitud"
      v-on:cerrar="modalMotivoCerrado($event)"
    />
    <!-- Modal de logo, beneficio y comentario -->
    <div v-show="!cargando">
      <div id="modalInfo" class="modal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h2
                class="modal-title"
                v-if="solicitudVista && solicitudVista.comercio"
              >
                <span>{{ solicitudVista.comercio.name }} - </span>
                <span v-if="modoModalInfo == ModoModal.beneficio"
                  >Beneficio</span
                >
                <span v-if="modoModalInfo == ModoModal.logo">Logo</span>
                <span v-if="modoModalInfo == ModoModal.comentario"
                  >Comentarios</span
                >
              </h2>
              <div class="acciones-modal">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div class="modal-body">
              <div v-if="solicitudVista && solicitudVista.comercio">
                <!-- Modo Logo -->
                <vue-load-image
                  v-if="
                    modoModalInfo == ModoModal.logo &&
                    solicitudVista.comercio.logoUrl
                  "
                >
                  <!-- Logo -->
                  <img
                    slot="image"
                    id="logo"
                    :src="CarpetaLogos + solicitudVista.comercio.logoUrl"
                    alt="Error al cargar logo"
                  />
                  <!-- Indicador de carga -->
                  <div slot="preloader">
                    <div class="d-flex justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <!-- Mensaje de error -->
                  <div slot="error">
                    <div class="alert alert-danger" role="alert">
                      Ocurrió un error al cargar la imagen
                    </div>
                  </div>
                </vue-load-image>

                <!-- Modo Beneficio -->
                <div
                  v-if="
                    modoModalInfo == ModoModal.beneficio &&
                    solicitudVista.beneficio
                  "
                  class="modal-beneficio-container"
                >
                  <!-- Tabla info beneficio -->
                  <div class="table-responsive">
                    <table id="lista" class="table table-hover table-striped">
                      <tr>
                        <th>Nombre</th>
                        <td>{{ solicitudVista.beneficio.name }}</td>
                      </tr>
                      <tr>
                        <th>Porcentaje de Descuento</th>
                        <td>
                          {{ solicitudVista.beneficio.discountPercentage }}
                        </td>
                      </tr>
                      <tr>
                        <th>Categoría</th>
                        <td>{{ solicitudVista.beneficio.categoriaName }}</td>
                      </tr>
                      <tr>
                        <th>Sub Categoría</th>
                        <td>
                          <span v-if="solicitudVista.beneficio.subcategoria">
                            {{ solicitudVista.beneficio.subcategoria.name }}
                          </span>
                          <span v-else> Sin subcategoría </span>
                        </td>
                      </tr>
                      <tr>
                        <th>Permite Invitado</th>
                        <td>
                          {{
                            solicitudVista.beneficio.allowsVisita ? "Si" : "No"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Días habilitados</th>
                        <td>
                          {{
                            solicitudVista.beneficio.diaHabilitadoList
                              | diasSemana
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Medio de pago</th>
                        <td>{{ solicitudVista.beneficio.payMethod }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <!-- Modo Comentario -->
                <div v-if="modoModalInfo == ModoModal.comentario">
                  <p>{{ solicitudVista.comercio.observations }}</p>
                </div>
              </div>
              <div
                v-if="!solicitudVista || !solicitudVista.comercio"
                class="alert alert-danger"
                role="alert"
              >
                Error al cargar datos
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cantidad === 0" class="alert alert-primary" role="alert">
        No hay solicitudes pendientes
      </div>
      <!--Tabla de solicitudes-->
      <div v-if="cantidad > 0" class="table-responsive">
        <table id="lista" class="table table-hover">
          <thead>
            <tr>
              <th>Acción</th>
              <th>Comercio</th>
              <th>Teléfono</th>
              <th>Email</th>
              <th>Dirección</th>
              <th>CUIT</th>
              <th>Provincia</th>
              <th>Localidad</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!cargandoLista">
              <template v-for="(sol, index) in solicitudes">
                <tr
                  v-bind:key="sol.comercio.id"
                  data-toggle="collapse"
                  :data-target="'#fila' + index"
                  class="fila-expandible"
                >
                  <td>
                    <div class="opciones-de-elemento">
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="aceptar(sol)"
                      >
                        <font-awesome-icon :icon="Icons.ACEPTAR" />
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning"
                        v-on:click.stop="clickEditar(sol)"
                      >
                        <font-awesome-icon :icon="Icons.EDITAR" />
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="rechazar(sol)"
                      >
                        <font-awesome-icon :icon="Icons.RECHAZAR" />
                      </button>
                    </div>
                  </td>
                  <th scope="row">{{ sol.comercio.name }}</th>
                  <td>{{ sol.comercio.phone }}</td>
                  <td>{{ sol.comercio.email }}</td>
                  <td>{{ sol.comercio.address }}</td>
                  <td>{{ sol.comercio.cuit }}</td>
                  <td>{{ sol.comercio.provincia.name }}</td>
                  <td>{{ sol.comercio.localidad.name }}</td>
                </tr>
                <!-- Filas expandibles -->
                <tr
                  v-bind:key="'expandible' + index"
                  class="collapse"
                  :id="'fila' + index"
                >
                  <!-- Beneficio -->
                  <td v-if="sol.beneficio">
                    <button
                      type="button"
                      class="btn btn-link"
                      v-if="!!sol.beneficio"
                      @click="verBeneficio(sol)"
                    >
                      <font-awesome-icon :icon="Icons.BENEFICIO" />
                      Beneficio
                    </button>
                  </td>
                  <!-- Logo -->
                  <td>
                    <button
                      v-if="sol.comercio.logoUrl"
                      type="button"
                      class="btn btn-link"
                      @click="verLogo(sol)"
                    >
                      <font-awesome-icon :icon="Icons.IMAGEN" />
                      Logo
                    </button>
                    <p v-if="!sol.comercio.logoUrl">Solicitud sin logo</p>
                  </td>
                  <!-- Comentarios -->
                  <td>
                    <button
                      v-if="sol.comercio.observations"
                      type="button"
                      class="btn btn-link"
                      @click="verComentarios(sol)"
                    >
                      <font-awesome-icon :icon="Icons.COMENTARIO" />
                      Comentarios
                    </button>
                  </td>
                </tr>
              </template>
            </template>
            <tr v-if="cargandoLista">
              <td colspan="5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="cantidad > 0"
        class="alert alert-secondary alert-dismissible fade show"
        role="alert"
      >
        Puede ver información extra haciendo click en la fila de cada solicitud.
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Paginacion
        :cantidad="cantidad"
        :cantidadPorPagina="CantidadPorPagina"
        v-on:pagina-cambiada="paginaCambiada"
      />
    </div>
    <div v-if="cargando" class="spinner-border" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";
import VueLoadImage from "vue-load-image";

import { Carpetas, Icons as IconConstants } from "../../constants";
import { environment } from "../../environments/environment";
import Paginacion from "../Paginacion";
import ModalSolicitud from "./modals/ModalSolicitud";
import { Util } from "../../util";
import ModalMotivoSolicitud from "./modals/ModalMotivoSolicitud.vue";

import { SolicitudComercioFacade as Facade } from "../../service/admin/solicitud-comercio/solicitud-comercio.facade";

const CANTIDAD_POR_PAGINA = 10;

/**Tiempo en milisegundos durante el que se muestran los mensajes de resultado */
const TIEMPO_RESULTADO = 2000;

const SOLICITUD_LIMPIA = {
  beneficio: {
    diasHabilitados: [],
  },
  comercio: {
    idLocalidad: null,
  },
};

// El mismo modal se usa para mostrar información diferente
const ModoModal = Object.freeze({
  ninguno: 0,
  beneficio: 1,
  logo: 2,
  comentario: 3,
});

export default {
  components: {
    FontAwesomeIcon,
    VueLoadImage,
    ModalMotivoSolicitud,
    ModalSolicitud,
    Paginacion,
  },
  computed: {
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    /**Usado para paginar, para indicar la cantidad mostrada por pagina */
    CantidadPorPagina() {
      return CANTIDAD_POR_PAGINA;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    // Usado en la vista para acceder al enumerado
    ModoModal() {
      return ModoModal;
    },
    PesoMaximoLogo() {
      return environment.LOGO_PESO_MAXIMO;
    },
  },
  data() {
    return {
      cantidad: 0,
      /**Usado para mostrar un gráfico de carga cuando se están
       * cargando las solicitudes*/
      cargando: true,
      cargandoLista: false,
      solicitudes: [],
      /**Solicitud que está siendo vista */
      solicitudVista: {
        comercio: null,
        beneficio: null,
      },
      /**Mensaje que se muestra en caso de error o al guardar elemento*/
      mensajeResultado: "",
      /**Modal para mostrar logos */
      modalInfo: null,
      /**Usado para alternar el modal entre beneficio y logo */
      modoModalInfo: ModoModal.ninguno,
      numeroDePagina: 1,
      solicitudParaRechazar: {},
    };
  },
  watch: {
    mensajeResultado() {
      // Eliminar mensaje dentro de unos segundos
      window.setTimeout(() => (this.mensajeResultado = null), TIEMPO_RESULTADO);
    },
  },
  created() {
    Facade.count().then((count) => {
      this.cantidad = count;

      if (this.cantidad > 0) {
        this.cargarLista();
      } else {
        this.cargando = false;
      }
    });
  },
  mounted() {
    const modalElement = document.getElementById("modalInfo");
    const opciones = {};
    this.modalInfo = new bootstrap.Modal(modalElement, opciones);

    modalElement.addEventListener("hidden.bs.modal", () => {
      this.modalCerrado();
    });
  },
  methods: {
    // Cuando se guardó la edición de un item (en este caso una solicitud)
    editado(itemEnServer) {
      // Las solicitudes se identifican por su id de comercio
      const indiceSolicitud = this.solicitudes.findIndex(
        (s) => s.comercio.id == itemEnServer.comercio.id
      );

      this.solicitudes[indiceSolicitud] = itemEnServer;

      // Si justo se editó la vista
      if (
        this.solicitudVista &&
        this.solicitudVista.comercio.id == itemEnServer.comercio.id
      )
        this.solicitudVista = itemEnServer;
    },
    clickEditar(solicitud) {
      this.solicitudVista = solicitud;

      // Abrir modal de edición
      this.$refs.modalSolicitud.EventoAbrir(solicitud);
    },
    limpiarSolicitudVista() {
      this.solicitudVista = Util.copiaProfunda(SOLICITUD_LIMPIA);
    },
    modalEdicionCerrado() {},
    /**Muestra modal con el beneficio */
    verBeneficio(solicitud) {
      this.solicitudVista = solicitud;
      this.mostrarModal(ModoModal.beneficio);
    },
    /**Muestra modal con el logo */
    verLogo(solicitud) {
      this.solicitudVista = solicitud;
      this.mostrarModal(ModoModal.logo);
    },
    verComentarios(solicitud) {
      this.solicitudVista = solicitud;
      this.mostrarModal(ModoModal.comentario);
    },
    mostrarModal(modo) {
      this.modoModalInfo = modo;
      this.modalInfo.show();
    },
    // Cuando el usuario cierra el modal
    modalCerrado() {
      this.limpiarSolicitudVista();
    },
    aceptar(solicitud) {
      Swal.fire({
        title: "Aceptar: " + solicitud.comercio.name,
        text: "Seguro que desea aceptar esta solicitud?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        // Si confirma que quiere aceptar
        if (result.isConfirmed) {
          Facade.accept(solicitud)
            .then(() => {
              Swal.fire(
                "Confirmación",
                "La solicitud ha sido aceptada",
                "success"
              );
              this.cantidad--;
              this.cargarLista();
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: "Problemas",
                text: "Ocurrió un error al aceptar la solicitud.",
              });
            });
        }
      });
    },
    modalMotivoCerrado(motivoRechazo) {
      this.solicitudParaRechazar.motivoRechazo = motivoRechazo;

      Swal.fire({
        title: "Rechazar: " + this.solicitudParaRechazar.comercio.name,
        text: "Seguro que desea rechazar esta solicitud?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Rechazar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        // Si confirma que quiere rechazar
        if (result.isConfirmed) {
          Facade.reject(this.solicitudParaRechazar)
            .then(() => {
              Swal.fire(
                "Confirmación",
                "La solicitud ha sido rechazada",
                "success"
              );
              this.cantidad--;
              this.cargarLista();
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: "Problemas",
                text: "Ocurrió un error al rechazar la solicitud.",
              });
            });
        }
      });
    },
    rechazar(solicitud) {
      this.solicitudParaRechazar = solicitud;
      this.$refs.modalMotivoSolicitud.EventoAbrir();
    },
    cargarLista() {
      // Cuando el numeroDePagina es 0, no se puede pedir una página válida,
      // Este caso se da cuando la cantidad es 0
      if (this.numeroDePagina > 0 && this.cantidad > 0) {
        this.cargandoLista = true;
        // Parámetros de paginación
        const desde = (this.numeroDePagina - 1) * this.CantidadPorPagina + 1;
        const hasta = this.numeroDePagina * this.CantidadPorPagina;

        Facade.getList({ fromIndex: desde, toIndex: hasta }).then((list) => {
          this.solicitudes = list;
          this.cargandoLista = false;
          this.cargando = false;
        });
      } else {
        this.solicitudes = [];
        this.cargandoLista = false;
        this.cargando = false;
      }
    },
    paginaCambiada(numero) {
      this.numeroDePagina = numero;
      this.cargarLista();
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
h3 {
  font-size: 20px;
}
#indicador-guardar-edicion {
  width: 16px;
  height: 16px;
}
.opciones-de-elemento {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
}
#logo {
  max-width: 100%;
  max-height: 100%;
}
</style>
